import { useEffect, useCallback, useState } from 'react';
import { AUTH_API } from '../../../api/amplify';
import { AreaLoader } from '../../UI';
import { wait } from '../../../utils/commonHelpers';

export const ElamaAuthPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  const navigateToElamaAuth = useCallback(async () => {
    await wait(2000);
    await AUTH_API.elamaSignIn();
    setIsLoading(false);
  }, []);

  useEffect(() => {
    navigateToElamaAuth();
  }, [navigateToElamaAuth]);

  if (isLoading) {
    return <AreaLoader message={'Авторизация'} />;
  }

  return null;
};
